import { render, staticRenderFns } from "./rename-modal.vue?vue&type=template&id=29dd9c79&scoped=true"
import script from "./rename-modal.vue?vue&type=script&lang=js"
export * from "./rename-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dd9c79",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29dd9c79')) {
      api.createRecord('29dd9c79', component.options)
    } else {
      api.reload('29dd9c79', component.options)
    }
    module.hot.accept("./rename-modal.vue?vue&type=template&id=29dd9c79&scoped=true", function () {
      api.rerender('29dd9c79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/video-screen-recording/rename-modal.vue"
export default component.exports